import Vue from "vue";
import VueRouter from "vue-router";
import { getAllUrlQuery } from "@/utils/uri";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      hideTitle: true,
    },
  },
  {
    path: "/intelligentWriting",
    name: "IntelligentWriting",
    component: () => import("@/views/intelligentWriting/index.vue"),
    meta: {
      title: "AI写稿",
      // hideTitle: true,
    },
  },
  {
    path: "/manuscriptList",
    name: "ManuscriptList",
    component: () => import("@/views/manuscriptList/index.vue"),
    meta: {
      title: "AI写稿",
      // hideTitle: true,
    },
  },
  {
    path: "/basicInfo",
    name: "BasicInfo",
    component: () => import("@/views/basicInfo/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/aiGenerateContent",
    name: "AiGenerateContent",
    component: () => import("@/views/aiGenerateContent/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/aiWriteManuscript",
    name: "AiWriteManuscript",
    component: () => import("@/views/aiWriteManuscript/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/subjectInfo",
    name: "SubjectInfo",
    component: () => import("@/views/subjectInfo/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/versionHeaderInfor",
    name: "VersionHeaderInfor",
    component: () => import("@/views/versionHeaderInfor/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/manuscriptOutline",
    name: "ManuscriptOutline",
    component: () => import("@/views/manuscriptOutline/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/aiGenerateManuscript",
    name: "AiGenerateManuscript",
    component: () => import("@/views/aiGenerateManuscript/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/argumentEditing",
    name: "ArgumentEditing",
    component: () => import("@/views/argumentEditing/index.vue"),
    meta: {
      title: "AI写稿",
    },
  },
  {
    path: "/compareContext",
    name: "CompareContext",
    component: () => import("@/views/compareContext/index.vue"),
    meta: {
      title: "AI比稿",
      hideTitle() {
        const { pc } = getAllUrlQuery();
        return !!pc;
      },
    },
  },
  {
    path: "/intelligentAIWriting",
    name: "IntelligentAIWriting",
    component: () => import("@/views/intelligentAIWriting/index.vue"),
    meta: {
      title: "AI写稿",
      hideTitle: true,
    },
  },
  {
    path: "/subApp",
    name: "SubApp",
    component: () => import("@/views/sub-app/index.vue"),
  },
  {
    path: "/subAppSearch",
    name: "SubAppSearch",
    component: () => import("@/views/sub-app-search/index.vue"),
  },
];

export default routes;
